export default class CtaLarge {
    visible = false;
}

document.addEventListener("alpine:init", () => {
    Alpine.data("ctaLarge", () => new CtaLarge());
});
